"use strict";

var store = require('../../../store');
var _require = require('./adyen_checkout/renderGenericComponent'),
  renderGenericComponent = _require.renderGenericComponent;
var _require2 = require('./adyen_checkout/checkoutConfiguration'),
  setCheckoutConfiguration = _require2.setCheckoutConfiguration,
  actionHandler = _require2.actionHandler;
setCheckoutConfiguration();
if (window.cardholderNameBool !== 'null') {
  store.checkoutConfiguration.paymentMethodsConfiguration.card.hasHolderName = true;
  store.checkoutConfiguration.paymentMethodsConfiguration.card.holderNameRequired = true;
}
if (window.googleMerchantID !== 'null' && window.Configuration.environment === 'live') {
  var id = 'merchantId';
  store.checkoutConfiguration.paymentMethodsConfiguration.paywithgoogle.configuration[id] = window.googleMerchantID;
  store.checkoutConfiguration.paymentMethodsConfiguration.googlepay.configuration[id] = window.googleMerchantID;
}

module.exports = {
  renderGenericComponent: renderGenericComponent,
  actionHandler: actionHandler
};
